import React from 'react';
import styled from 'styled-components';
import Icon from 'components/Icon';

const CartItemContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: ${(props) =>
    props.theme.name === 'dark'
      ? props.theme.colors?.background?.overlay || 'rgba(255, 255, 255, 0.03)'
      : 'rgba(0, 0, 0, 0.02)'};
  border-radius: 8px;
  margin-bottom: 8px;
`;

const CartItemQty = styled.span`
  background: ${(props) =>
    props.theme.name === 'dark'
      ? 'rgba(250, 70, 22, 0.15)'
      : 'rgba(250, 70, 22, 0.1)'};
  color: ${(props) => props.theme.colors?.primary || '#FA4616'};
  padding: 6px 10px;
  border-radius: 6px;
  font-weight: 700;
  font-size: 13px;
`;

const CartItemName = styled.span`
  flex: 1;
  font-size: 14px;
  color: ${(props) =>
    props.theme.name === 'dark'
      ? props.theme.colors?.text?.primary || '#ffffff'
      : '#000033'};
`;

const CartItemPrice = styled.span`
  font-weight: 700;
  font-size: 14px;
  color: ${(props) =>
    props.theme.name === 'dark'
      ? props.theme.colors?.text?.primary || '#ffffff'
      : '#000033'};
`;

const RemoveButton = styled.button`
  background: none;
  border: none;
  color: ${(props) =>
    props.theme.name === 'dark'
      ? props.theme.colors?.textGray?.muted || '#64748B'
      : '#94A3B8'};
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s ease;

  &:hover {
    color: ${(props) => props.theme.colors?.error || '#EF4444'};
  }
`;

/**
 * POSCartItem - A cart item row for POS cart display
 *
 * @param {Object} props
 * @param {number} props.quantity - Number of items
 * @param {string} props.name - Item name
 * @param {string} props.price - Formatted price string
 * @param {Function} props.onRemove - Callback when removing the item
 */
const POSCartItem = ({ quantity, name, price, onRemove }) => {
  return (
    <CartItemContainer>
      <CartItemQty>{quantity}</CartItemQty>
      <CartItemName>{name}</CartItemName>
      <CartItemPrice>{price}</CartItemPrice>
      <RemoveButton onClick={onRemove}>
        <Icon icon="trash" size={16} color="currentColor" />
      </RemoveButton>
    </CartItemContainer>
  );
};

export default POSCartItem;
